import { Text } from '@hopin-team/ui-text';
import { rem } from 'polished';
import styled from 'styled-components';

export const FullHeight = styled.div`
  height: 100%;
`;

export const FillWindow = styled.div`
  height: 100vh;
`;

export const OverlayContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem(16)};
  position: absolute;
  z-index: 2;
  text-align: center;
  background: ${props => props.theme.COLOR.GREY.WHITE};
`;

export const LinkButton = styled(Text)`
  background-color: transparent;
`;

LinkButton.defaultProps = {
  element: 'button',
  type: 'button',
  color: 'theme-primary',
  pattern: 'strong',
};
